// In eine IIFE gekapselt: Top-Level-const/let teilen sich sonst den globalen Bereich
// mit anderen Skripten ("Identifier 'sfs' has already been declared", wenn ein anderes
// Skript ebenfalls sfs deklariert). Global sichtbar sind nur window.sfs und
// window.decodeBase64Utf8 (wird von sfs_keyvalues.js für das Wetter benötigt).
(function () {

// Lokale Referenz: bleibt gültig, auch wenn ein anderes Skript window.sfs später ersetzt
const sfs = window.sfs = window.sfs || {};

// Doppelt eingebunden (z. B. über zwei Vorlagen) → nur einmal starten,
// sonst doppelte Timer, Listener und API-Abfragen
if (sfs.chartsLoaded) return;
sfs.chartsLoaded = true;

Chart.register(ChartDataLabels);

sfs.myCharts = sfs.myCharts || {};
sfs.chartConfigs = sfs.chartConfigs || {};
sfs.refreshTimers = sfs.refreshTimers || {};
sfs.elementCache = new Map();

// ─── CSS-Variablen auslesen ───────────────────────────────────────────────────
// FIX 1: CSS-Variablen werden erst in DOMContentLoaded initialisiert,
//         damit Stylesheets sicher geladen sind.

const getCSSVar = name => getComputedStyle(document.documentElement).getPropertyValue(name).trim();
const getIntVar = name => parseInt(getCSSVar(name)) || 0;
const getFloatVar = name => parseFloat(getCSSVar(name)) || 0;

const initChartTheme = () => {
  sfs.chartFonts = {
    legend:    { size: getIntVar("--text-base-font-size"),  family: getCSSVar("--font-family-light") },
    dataLabel: { size: getIntVar("--text-base-font-size"),  family: getCSSVar("--font-family-light") },
    axisTicks: { size: getIntVar("--text-base-font-size"),  family: getCSSVar("--font-family-light") },
    titleBold: { size: getIntVar("--text-base-font-size"),  family: getCSSVar("--font-family-bold"), weight: getCSSVar("--font-weight-bold") }
  };

  sfs.chartColorsConfig = {
    black:      getCSSVar("--chart-grid-color-black"),
    white:      getCSSVar("--chart-value-color-white"),
    red:        getCSSVar("--color-primary"),
    gaugeTrack: getCSSVar("--chart-gauge-track-color") || "#ccc"   // CD-Hellgrau
  };

  sfs.chartDefaults = {
    legendSpacing:       getIntVar("--chart-legend-spacing"),
    animationDuration:   getIntVar("--chart-animation-duration"),
    observerThreshold:   getFloatVar("--chart-observer-threshold"),
    datasetsTension:     getFloatVar("--chart-datasets-tension"),
    offsetDoughnutValue: getIntVar("--chart-value-offset-doughnut"),
    offsetBarValue:      getIntVar("--chart-value-offset-bar")
  };
};

// ─── Hilfsfunktionen ─────────────────────────────────────────────────────────

const formatNumber = n => {
  if (n === "" || n === null || n === undefined) return "";
  // FIX 1 (Folge): chartFonts/chartColorsConfig/chartDefaults sind erst nach
  //                initChartTheme() verfügbar; formatNumber braucht sie nicht,
  //                aber der Sprachfallback wird jetzt explizit auf "de-CH" gesetzt.
  const lang = document.documentElement.lang || "de-CH";
  return Number(n).toLocaleString(lang);
};

const decodeBase64Utf8 = str => {
  try {
    return new TextDecoder("utf-8").decode(Uint8Array.from(atob(str), c => c.charCodeAt(0)));
  } catch (e) {
    // FIX: Fehler werden geloggt statt stillschweigend ignoriert
    console.warn("Base64 decode failed:", e);
    return "";
  }
};

const parseFlexibleLocalData = str => {
  if (!str) return { labels: [], datasets: [] };

  const cleaned = str.replace(/(\d)[\u0027\u2019\u202F\u00A0\u0020](\d)/g, "$1$2");

  try {
    const parsed = JSON.parse(cleaned);
    if (Array.isArray(parsed) && parsed[0] && parsed[0].length === 2) {
      return {
        labels:   parsed.map(d => d[0]),
        datasets: [{ label: "Local", data: parsed.map(d => d[1]) }]
      };
    }
    if (parsed.labels && parsed.datasets) return parsed;
  } catch (e) {
    const arr = cleaned.split(",")
      .map(e => {
        const parts = e.split(":");
        if (parts.length < 2) return null;
        const label = parts[0];
        const val   = parts.slice(1).join(":");
        const num   = parseFloat(val);
        return !isNaN(num) ? [label.trim(), num] : null;
      })
      .filter(Boolean);

    if (arr.length) {
      return {
        labels:   arr.map(d => d[0]),
        datasets: [{ label: "Local", data: arr.map(d => d[1]) }]
      };
    }
  }
  return { labels: [], datasets: [] };
};

// FIX 2: el.isConnected ist semantisch präziser als document.contains(el)
const getCachedElement = id => {
  let el = sfs.elementCache.get(id);
  if (!el || !el.isConnected) {
    el = document.getElementById(id);
    if (el) sfs.elementCache.set(id, el);
  }
  return el;
};

const MOBILE_BREAKPOINT = 640;
const isMobileView = () => window.innerWidth < MOBILE_BREAKPOINT;

// Mit stepSize erzeugt Chart.js bis zu 1000 Achsenstriche (z. B. Schrittweite 5 bei
// Werten im Tausenderbereich). Ergäbe die Schrittweite mehr als MAX_STEP_TICKS Striche,
// wird sie weggelassen und Chart.js wählt sie selbst (max. 11 Striche).
// Übliche Wertebereiche bleiben unverändert.
const MAX_STEP_TICKS = 50;

// Horizontale Balken: Abstand rechts für die Wertbeschriftung (px)
const HORIZONTAL_VALUE_SPACE = 50;

// Legende mit Werten: Kreis-/Ring-Segment rückt beim Hover um so viele px heraus
const DETAILED_HOVER_OFFSET = 8;

// Horizontale Balken: Chart.js gibt der Label-Achse höchstens etwa die halbe Chartbreite
// und schneidet längere Labels links ab. Deshalb werden Labels umbrochen, sobald sie
// breiter als dieser Anteil der Chartbreite sind (gemessen in Pixel).
const LABEL_MAX_SHARE = 0.4;

const wrapLabel = (label, maxWidth, measure) => {
  const words = String(label).split(" ");
  const lines = [];
  let line = "";

  words.forEach(word => {
    if (line && measure(line + " " + word) > maxWidth) {
      lines.push(line);
      line = word;
    } else {
      line = line ? line + " " + word : word;
    }
  });
  if (line) lines.push(line);

  return lines.length > 1 ? lines : lines[0] || "";
};

const getStepSize = (chartData, config) => {
  const pos = [];
  const neg = [];
  let max = 0;
  let min = 0;

  chartData.datasets.forEach(ds => {
    (ds.data || []).forEach((v, i) => {
      const n = parseFloat(v);
      if (isNaN(n)) return;
      if (config.stacked) {
        if (n > 0) pos[i] = (pos[i] || 0) + n;
        else       neg[i] = (neg[i] || 0) + n;
      } else {
        max = Math.max(max, n);
        min = Math.min(min, n);
      }
    });
  });

  if (config.stacked) {
    max = Math.max(0, ...pos.filter(n => n != null));
    min = Math.min(0, ...neg.filter(n => n != null));
  }

  return (max - min) / config.stepSize > MAX_STEP_TICKS ? undefined : config.stepSize;
};

// ─── Daten laden ─────────────────────────────────────────────────────────────

// Hängt die API länger, wird die Anfrage abgebrochen (zählt als Fehler)
const REQUEST_TIMEOUT = 15000;

// Liefert null bei einem API-Fehler (damit der Chart die letzten Daten behält)
const requestData = async (apiProxyUrl, endpoint, endpointfilter, useDatasets, localDatasets, stacked, chartLang) => {
  if (useDatasets) return localDatasets;
  if (!endpoint && !stacked) return { labels: [], datasets: [] };
  if (!endpoint) return localDatasets;

  const mobile = isMobileView();
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT);

  try {
    const url = new URL(decodeURIComponent(apiProxyUrl || "") + "de.pinuts.sfs.api/" + endpoint);

    if (endpointfilter) url.searchParams.set("filter", endpointfilter);
    if (mobile)         url.searchParams.set("mobile", "true");
    if (chartLang)      url.searchParams.set("lang", chartLang);

    const res = await fetch(url.toString(), { signal: controller.signal });
    if (!res.ok) throw new Error("HTTP " + res.status);

    const data = await res.json();
    let valid = { labels: [], datasets: [] };

    if (Array.isArray(data) && data[0] && data[0].length === 2) {
      valid = {
        labels:   data.map(d => d[0]),
        datasets: [{ label: endpoint, data: data.map(d => d[1] === 0 ? "" : d[1]) }]
      };
    } else if (Array.isArray(data) && data[0] && data[0].length === 1) {
      // Einzelwert wie bei den Bubble-Endpunkten ([[42]]), z. B. für "gauge"
      valid = {
        labels:   data.map(() => ""),
        datasets: [{ label: endpoint, data: data.map(d => d[0] === 0 ? "" : d[0]) }]
      };
    } else if (data.labels && data.datasets) {
      valid = {
        labels:   data.labels,
        datasets: data.datasets.map(ds => ({
          label: ds.label,
          data:  ds.data.map(val => val === 0 ? "" : val)
        }))
      };
    }

    return valid;
  } catch (e) {
    console.error("API fetch error:", e);
    return null;
  } finally {
    clearTimeout(timeout);
  }
};

// Öffentliche Variante (wie bisher): leere Daten bei Fehler
sfs.fetchData = async (...args) => {
  const data = await requestData(...args);
  return data === null ? { labels: [], datasets: [] } : data;
};

// ─── Legende ─────────────────────────────────────────────────────────────────

// Per DOM aufgebaut (textContent): Labels aus der API werden nie als HTML interpretiert
sfs.createLegend = (labels, colors, legendId) => {
  const el = getCachedElement(legendId);
  if (!el || !Array.isArray(labels)) return;

  el.textContent = "";
  labels.forEach((label, i) => {
    const item   = document.createElement("div");
    const swatch = document.createElement("span");
    const text   = document.createElement("span");

    item.className = "legend-item";
    swatch.className = "legend-color";
    swatch.style.backgroundColor = colors[i];
    text.style.color = sfs.chartColorsConfig.black;
    text.textContent = String(label).replace(/[<>]/g, "");

    item.append(swatch, text);
    el.appendChild(item);
  });
};

// ─── Legende "Mit Werten und Anteilen" ───────────────────────────────────────
// data-legend-style="detailed": pro Eintrag Farbe, Name, Wert und Anteil, dazu eine
// Total-Zeile. Hover auf einen Eintrag hebt das Segment hervor und umgekehrt; bei
// Kreis/Ring blendet ein Klick (oder Enter/Leertaste) das Segment aus und wieder ein.
// Die Anteile beziehen sich immer auf das Total aller Werte.

const highlightLegend = (el, index) => {
  if (!el) return;
  el.classList.toggle("has-active", index != null);
  el.querySelectorAll(".legend-row[data-index]").forEach(row => {
    row.classList.toggle("is-active", Number(row.dataset.index) === index);
  });
};

const createDetailedLegend = (chart, chartData, config, legendId, canToggle) => {
  const el = getCachedElement(legendId);
  if (!el) return;

  const labels = chartData.labels || [];
  const values = ((chartData.datasets[0] || {}).data || []).map(v => parseFloat(v) || 0);
  const total  = values.reduce((sum, v) => sum + v, 0);
  const colors = config.chartColors;

  const cell = (className, text) => {
    const span = document.createElement("span");
    span.className = className;
    if (text != null) span.textContent = text;
    return span;
  };

  const row = (name, value, share, color) => {
    const item   = document.createElement("div");
    const swatch = cell("legend-color");
    if (color) swatch.style.backgroundColor = color;

    item.className = "legend-row";
    item.append(swatch, cell("legend-name", name), cell("legend-value", value), cell("legend-share", share));
    return item;
  };

  el.textContent = "";
  el.style.color = sfs.chartColorsConfig.black;

  labels.forEach((label, i) => {
    const name = labelText(label).replace(/[<>]/g, "");
    const item = row(name, formatNumber(values[i]) + config.valueSuffix,
      total ? Math.round(values[i] / total * 100) + " %" : "–", colors[i % colors.length]);

    item.dataset.index = i;
    item.title = name;

    const setActive = active => {
      const items = active && chart.getDataVisibility(i) ? [{ datasetIndex: 0, index: i }] : [];
      chart.setActiveElements(items);
      if (chart.tooltip) chart.tooltip.setActiveElements(items, { x: 0, y: 0 });
      chart.update();
      highlightLegend(el, items.length ? i : null);
    };

    item.addEventListener("mouseenter", () => setActive(true));
    item.addEventListener("mouseleave", () => setActive(false));

    if (canToggle) {
      const visible = chart.getDataVisibility(i);
      item.classList.toggle("is-off", !visible);
      item.setAttribute("role", "button");
      item.setAttribute("aria-pressed", String(visible));
      item.tabIndex = 0;

      const toggle = () => {
        chart.toggleDataVisibility(i);
        const on = chart.getDataVisibility(i);
        item.classList.toggle("is-off", !on);
        item.setAttribute("aria-pressed", String(on));
        setActive(false);
      };

      item.addEventListener("click", toggle);
      item.addEventListener("keydown", e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });
    }

    el.appendChild(item);
  });

  const totalRow = row("Total", formatNumber(total) + config.valueSuffix, total ? "100 %" : "–", null);
  totalRow.classList.add("legend-total");
  el.appendChild(totalRow);
};

// ─── Daten-Vergleich ─────────────────────────────────────────────────────────

const isDataChanged = (oldDatasets, newData) => {
  if (!oldDatasets || !newData) return true;

  const oldLabels = oldDatasets.labels || [];
  const newLabels = newData.labels   || [];

  if (oldLabels.join(",") !== newLabels.join(",")) return true;
  if (oldDatasets.datasets.length !== newData.datasets.length) return true;

  for (let i = 0; i < newData.datasets.length; i++) {
    const oldVals = (oldDatasets.datasets[i].data || []).map(String).join(",");
    const newVals = (newData.datasets[i].data     || []).map(String).join(",");
    if (oldVals !== newVals) return true;
  }
  return false;
};

// ─── Legend-Spacing-Plugin ────────────────────────────────────────────────────
// FIX 3: afterInit statt beforeInit – chart.legend.fit ist erst nach der
//         Initialisierung zuverlässig vorhanden.

const legendSpacingPlugin = {
  id: "legendSpacing",
  afterInit: function(chart) {
    const legend = chart.legend;
    if (!legend) return;

    const originalFit = legend.fit.bind(legend);
    legend.fit = function() {
      originalFit();
      this.height += sfs.chartDefaults.legendSpacing;
    };
  }
};

// ─── Gauge-Text-Plugin ───────────────────────────────────────────────────────
// Schreibt bei data-type="gauge" den Wert (und optional "von {goal}") in den Halbring.

const gaugeTextPlugin = {
  id: "sfsGaugeText",
  afterDraw: function(chart) {
    const gauge = chart.$sfsGauge;
    const arc   = chart.getDatasetMeta(0).data[0];
    if (!gauge || !arc) return;

    const { x, y, innerRadius } = arc.getProps(["x", "y", "innerRadius"], true);
    const value = chart.data.datasets[0].data[0];
    const f     = sfs.chartFonts;
    const ctx   = chart.ctx;

    ctx.save();
    ctx.textAlign    = "center";
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle    = sfs.chartColorsConfig.black;

    const valueSize = Math.max(14, Math.round(innerRadius * 0.4));
    const labelSize = f.legend.size || 14;
    const valueY    = gauge.label ? y - labelSize - 8 : y - 4;

    ctx.font = (f.titleBold.weight || "bold") + " " + valueSize + "px " + (f.titleBold.family || "sans-serif");
    ctx.fillText(formatNumber(value || 0) + gauge.suffix, x, valueY);

    if (gauge.label) {
      ctx.font = labelSize + "px " + (f.legend.family || "sans-serif");
      ctx.fillText(gauge.label, x, y - 4);
    }
    ctx.restore();
  }
};

// Gestapelte Balken: Wert nur anzeigen, wenn er ins Segment passt (sonst ragt er
// in das Nachbarsegment); der Wert bleibt über den Tooltip sichtbar.
const LABEL_FIT_PADDING = 8;    // horizontal: Abstand gesamt (je 4 px links/rechts)
const LABEL_FIT_PADDING_V = 2;  // vertikal: Abstand gesamt oben/unten
const DIGIT_HEIGHT = 0.75;      // Ziffern sind ca. 3/4 so hoch wie die Schriftgrösse

// toText: liefert den angezeigten Text zum Wert (gleich wie der Formatter)
const labelFitsSegment = (context, horizontal, toText) => {
  const value = context.dataset.data[context.dataIndex];
  const el    = context.chart.getDatasetMeta(context.datasetIndex).data[context.dataIndex];
  if (!el || value === "" || value == null) return true;

  const { x, y, base, width, height } = el.getProps(["x", "y", "base", "width", "height"], true);
  const font = sfs.chartFonts.dataLabel;
  const ctx  = context.chart.ctx;

  ctx.save();
  ctx.font = (font.size || 12) + "px " + (font.family || "sans-serif");
  const textWidth = ctx.measureText(toText(value)).width;
  ctx.restore();

  const textHeight = (font.size || 12) * DIGIT_HEIGHT;

  return horizontal
    ? Math.abs(x - base) >= textWidth + LABEL_FIT_PADDING && height >= textHeight
    : Math.abs(base - y) >= textHeight + LABEL_FIT_PADDING_V && width >= textWidth;
};

// Kreis und Ring: Wert nur anzeigen, wenn er ins Segment passt. Gemessen wird die
// Bogenlänge auf dem Radius, auf dem die Zahl steht (Aussenrand + Offset), gegen die
// Diagonale der Zahl – so passt sie unabhängig von der Lage des Segments.
const labelFitsArc = (context, offset, toText) => {
  const value = context.dataset.data[context.dataIndex];
  const el    = context.chart.getDatasetMeta(context.datasetIndex).data[context.dataIndex];
  if (!el || value === "" || value == null) return true;

  const { startAngle, endAngle, innerRadius, outerRadius } =
    el.getProps(["startAngle", "endAngle", "innerRadius", "outerRadius"], true);
  const font = sfs.chartFonts.dataLabel;
  const ctx  = context.chart.ctx;

  ctx.save();
  ctx.font = (font.size || 12) + "px " + (font.family || "sans-serif");
  const textWidth = ctx.measureText(toText(value)).width;
  ctx.restore();

  const textHeight = (font.size || 12) * DIGIT_HEIGHT;
  const radius     = Math.max(outerRadius + offset, innerRadius);
  const arcLength  = radius * Math.abs(endAngle - startAngle);

  return arcLength >= Math.hypot(textWidth, textHeight) + LABEL_FIT_PADDING;
};

// Schriftfarbe für Werte im Segment: auf hellen Farben (z. B. #ccc, #999) dunkel,
// sonst hell. Helligkeit nach W3C (299R + 587G + 114B) / 1000.
const LIGHT_BACKGROUND = 150;

// Hex-Farbe als 6-stelligen Wert ohne "#" (#000 → "000000"); andere Formate → null
const expandHex = color => {
  const hex = String(color || "").trim().replace("#", "");
  if (/^[0-9a-f]{3}$/i.test(hex)) return hex.split("").map(ch => ch + ch).join("");
  if (/^[0-9a-f]{6}([0-9a-f]{2})?$/i.test(hex)) return hex.slice(0, 6);
  return null;
};

// Rahmenfarbe mit Transparenz (#000 → #00000080). Früher wurde "80" direkt angehängt,
// was bei 3-stelligen Farben (#000, #999, #ccc) eine ungültige Farbe ergab.
const withAlpha = (color, alpha) => {
  const full = expandHex(color);
  return full ? "#" + full + alpha : color;
};

const contrastText = (background, light, dark) => {
  const full = expandHex(background);
  if (!full) return light;

  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return (299 * r + 587 * g + 114 * b) / 1000 > LIGHT_BACKGROUND ? dark : light;
};

// ─── 100 %-Balken ────────────────────────────────────────────────────────────
// Jede Datenreihe (z. B. Standort) wird zu einem Balken mit 100 %; die Segmente sind
// die Labels (z. B. Antworten). Die Daten bleiben im üblichen Format
// { labels: [Antworten], datasets: [{ label: Standort, data: [...] }] }.

const PERCENT_STEP = 10;

const formatPercent = v => (v === "" || v == null || v === 0) ? null : Math.round(v) + " %";

const buildPercentData = (data, config) => {
  const sets   = data.datasets || [];
  const labels = data.labels || [];
  const totals = sets.map(ds => (ds.data || []).reduce((sum, v) => sum + (parseFloat(v) || 0), 0));

  return {
    // Kategorie = Datenreihe; optional mit Gesamtzahl als zweite Zeile, z. B. "(372 Antworten)"
    labels: sets.map((ds, si) => {
      const name = sets.length === 1 ? (config.datasetsTitle || "") : ds.label;
      return config.percentTotalLabel
        ? [name, config.percentTotalLabel.replace("{total}", formatNumber(totals[si]))]
        : name;
    }),
    datasets: labels.map((label, li) => ({
      label:  label,
      data:   sets.map((ds, si) => totals[si] ? (parseFloat(ds.data[li]) || 0) / totals[si] * 100 : 0),
      counts: sets.map(ds => parseFloat(ds.data[li]) || 0),
      ...buildDatasetProps(config, li)
    }))
  };
};

// ─── Barrierefreiheit ────────────────────────────────────────────────────────
// Canvas ist für Screenreader leer. role="img" und ein aria-label mit Titel und Werten
// beschreiben den Chart; bei neuen Daten wird das Label nachgeführt. Ein von der
// Vorlage gesetztes aria-label bleibt unverändert.

const labelText = label => Array.isArray(label) ? label.join(" ") : String(label == null ? "" : label);

const buildAriaLabel = (chartData, config, kind) => {
  const value = v => kind.percent ? Math.round(parseFloat(v) || 0) + " %" : formatNumber(v === "" ? 0 : v) + config.valueSuffix;
  const labels = chartData.labels || [];
  let parts;

  if (kind.gauge) {
    const ds = chartData.datasets[0] || { data: [] };
    parts = [formatNumber(ds.data[0] || 0) + config.valueSuffix + (config.goalLabel
      ? " " + config.goalLabel.replace("{goal}", formatNumber(config.goal)) : "")];
  } else if (kind.multi) {
    // Pro Datenreihe: "Heerbrugg: Hautscreening 159, Blutspende 95, …"
    parts = chartData.datasets.map(ds => labelText(ds.label) + ": "
      + labels.map((l, i) => labelText(l) + " " + value(ds.data[i])).join(", "));
  } else {
    const ds = chartData.datasets[0] || { data: [] };
    parts = [labels.map((l, i) => labelText(l) + " " + value(ds.data[i])).join(", ")];
  }

  // Ohne Titel nur die Werte (kein fester Text, da die Seiten mehrsprachig sind)
  return (config.datasetsTitle ? config.datasetsTitle + ". " : "") + parts.join(". ");
};

const setAriaLabel = (canvas, chartData, config, kind) => {
  if (canvas.hasAttribute("aria-label") && !canvas.hasAttribute("data-sfs-aria")) return;

  if (!canvas.hasAttribute("role")) canvas.setAttribute("role", "img");
  canvas.setAttribute("data-sfs-aria", "");
  canvas.setAttribute("aria-label", buildAriaLabel(chartData, config, kind));
};

// Summe aller Zahlen des ersten Datensatzes ("" = 0)
const sumFirstDataset = data => ((data.datasets && data.datasets[0] && data.datasets[0].data) || [])
  .reduce((sum, v) => sum + (parseFloat(v) || 0), 0);

// ─── Dataset-Eigenschaften ───────────────────────────────────────────────────

// Gemeinsame Darstellung für Balken- und Linien-Datensätze
const datasetStyle = config => ({
  borderWidth:        1,
  borderRadius:       { topLeft: 2, topRight: 2 },
  barThickness:       config.barThickness,
  barPercentage:      1.0,
  categoryPercentage: 1.0,
  tension:            sfs.chartDefaults.datasetsTension
});

// Gestapelt/gruppiert: eine Farbe pro Datensatz
const buildDatasetProps = (config, i) => {
  const color = config.chartColors[i % config.chartColors.length] || "#000";
  return {
    backgroundColor: color,
    borderColor:     withAlpha(color, "80"),
    ...datasetStyle(config)
  };
};

// ─── Chart erstellen / aktualisieren ─────────────────────────────────────────

sfs.createChart = (data, config) => {
  if (!data || !config || !config.canvasId) return;

  const canvas = getCachedElement(config.canvasId);
  if (!canvas) return;

  const ctx      = canvas.getContext("2d");
  const isGauge  = config.type === "gauge";
  const isPie    = ["pie", "doughnut"].includes(config.type) || isGauge;
  const isLine   = config.type === "line";
  const isBar    = config.type === "bar";
  const isPercent = isBar && config.percent;              // 100 %-Balken (immer gestapelt)
  const isStacked = config.stacked || isPercent;
  const c        = sfs.chartColorsConfig;
  const f        = sfs.chartFonts;
  const defaults = sfs.chartDefaults;

  // Balken-Varianten: horizontal (data-index-axis="y") und gruppiert (data-grouped="true")
  const isHorizontal = isBar && config.horizontal;
  const isGrouped    = isBar && config.grouped && !isStacked;
  const isMulti      = isStacked || isGrouped;            // mehrere Datensätze, Farbe pro Datensatz
  const valueAxis    = isHorizontal ? "x" : "y";
  const categoryAxis = isHorizontal ? "y" : "x";
  const showCategoryTicks = isMulti || isLine || isHorizontal;
  const rotateCategory    = (isMulti || isLine) && !isHorizontal;
  // Eigene HTML-Legende nur, wo die Kategorien nicht schon an der Achse stehen
  const useOwnLegend      = !isMulti && !isGauge && !isHorizontal;
  // Legende "Mit Werten und Anteilen" (FirstSpirit-Parameter), sonst wie bisher
  const isDetailedLegend  = useOwnLegend && config.legendStyle === "detailed";

  const isMobile           = isMobileView();
  const shouldRotateLabels = isMobile && data.labels && data.labels.length >= config.barThresholdMobile;
  const calculatedRotation = shouldRotateLabels
    ? config.barXAxisRotationMobile
    : config.barXAxisRotationDesktop;
  const minRotation        = shouldRotateLabels ? calculatedRotation : 0;
  const legendId           = "legend-" + config.canvasId.replace("chart-", "");
  const ariaKind           = { gauge: isGauge, multi: isMulti, percent: isPercent };

  const renderLegend = chart => isDetailedLegend
    ? createDetailedLegend(chart, chartData, config, legendId, isPie)
    : sfs.createLegend(chartData.labels, config.chartColors, legendId);

  // ── chartData aufbauen ──────────────────────────────────────────────────────
  let chartData;
  if (isPercent && data.labels && data.datasets) {
    chartData = buildPercentData(data, config);
  } else if (isMulti && data.labels && data.datasets) {
    chartData = {
      labels:   data.labels,
      datasets: data.datasets.map((ds, i) => ({
        ...ds,
        ...buildDatasetProps(config, i)
      }))
    };
  } else if (isGauge) {
    // Halbring: Wert und Rest bis zum Ziel (über dem Ziel: voller Ring)
    const value = sumFirstDataset(data);
    const goal  = config.goal > 0 ? config.goal : value;
    chartData = {
      labels:   ["", ""],
      datasets: [{
        data:            [value, Math.max(goal - value, 0)],
        backgroundColor: [config.chartColors[0], c.gaugeTrack],
        borderWidth:     0
      }]
    };
  } else if (isPie) {
    chartData = {
      labels:   data.labels || [],
      datasets: [{
        data:            (data.datasets && data.datasets[0] && data.datasets[0].data) || [],
        backgroundColor: config.chartColors,
        // Legende mit Werten: Segment beim Hover leicht herausrücken
        ...(isDetailedLegend ? { hoverOffset: DETAILED_HOVER_OFFSET } : {})
      }]
    };
  } else {
    // Einfacher Balken/Linie: jeder Balken in eigener Farbe
    chartData = {
      labels:   data.labels || [],
      datasets: [{
        label:           config.datasetsTitle || "",
        data:            (data.datasets && data.datasets[0] && data.datasets[0].data) || [],
        backgroundColor: config.chartColors,
        borderColor:     config.chartColors.map(color => withAlpha(color, "80")),
        ...datasetStyle(config)
      }]
    };
  }

  // ── Bestehenden Chart aktualisieren ─────────────────────────────────────────
  if (sfs.myCharts[config.canvasId]) {
    const chart       = sfs.myCharts[config.canvasId];
    const dataChanged = isDataChanged(chart.data, chartData);
    let optionsChanged = false;

    // Achsen an Breakpoint (mobil/desktop) und neue Datenmenge anpassen
    if (!isPie) {
      const categoryTicks = chart.options.scales[categoryAxis].ticks;
      if (rotateCategory && (categoryTicks.maxRotation !== calculatedRotation || categoryTicks.minRotation !== minRotation)) {
        categoryTicks.maxRotation = calculatedRotation;
        categoryTicks.minRotation = minRotation;
        optionsChanged = true;
      }

      const valueTicks = chart.options.scales[valueAxis].ticks;
      const stepSize   = isPercent ? PERCENT_STEP : getStepSize(chartData, config);
      if (valueTicks.stepSize !== stepSize) {
        valueTicks.stepSize = stepSize;
        optionsChanged = true;
      }
    }

    if (dataChanged) {
      chart.data.labels = chartData.labels;

      // FIX 4: Beim Update werden chart-typ-spezifische Eigenschaften
      //        (Farben, barThickness usw.) neu gesetzt, damit sie nach einer
      //        Datenänderung korrekt gerendert werden.
      chartData.datasets.forEach((ds, i) => {
        if (chart.data.datasets[i]) {
          Object.assign(chart.data.datasets[i], ds);
        } else {
          chart.data.datasets.push(ds);
        }
      });

      // Überschüssige Datasets entfernen (z.B. nach Filter-Änderung)
      if (chart.data.datasets.length > chartData.datasets.length) {
        chart.data.datasets.splice(chartData.datasets.length);
      }
    }

    if (dataChanged || optionsChanged) {
      chart.update();
    }

    // Eigene Legende an neue Labels/Werte anpassen
    if (dataChanged && useOwnLegend) renderLegend(chart);
    if (dataChanged) setAriaLabel(canvas, chartData, config, ariaKind);
    return;
  }

  // ── Neuen Chart erstellen ───────────────────────────────────────────────────
  // Einfache Balken: Wert ausserhalb des Balkens (oben bzw. rechts), schwarz
  const valueOutside = isBar && !isStacked;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: isHorizontal ? "y" : "x",
    layout: {
      padding: {
        top:    config.layoutPaddingTop,
        bottom: config.layoutPaddingBottom,
        left:   0,
        // Horizontal: Platz für die Werte rechts neben den Balken
        right:  isHorizontal ? HORIZONTAL_VALUE_SPACE : 0
      }
    },
    plugins: {
      title: config.datasetsTitle ? {
        display: true,
        text:    config.datasetsTitle,
        align:   "start",
        color:   c.black,
        font: {
          weight: config.datasetsTitleBold === "true" ? "bold" : f.legend.weight,
          size:   f.legend.size,
          family: config.datasetsTitleBold === "true" ? f.titleBold.family : f.legend.family
        },
        padding: { top: -20, bottom: 10 }
      } : false,
      legend: {
        display:  isMulti || isLine,
        position: "top",
        labels: {
          color:     c.black,
          font:      { weight: f.legend.weight, size: f.legend.size, family: f.legend.family },
          textAlign: "left"
        }
      },
      tooltip: {
        enabled: !isGauge && (isLine || config.pluginTooltip !== false),
        // 100 %: Anteil und Anzahl, z. B. "Rauchprävention: 28 % (10)"
        ...(isPercent ? {
          callbacks: {
            label: context => " " + context.dataset.label + ": " + Math.round(context.raw) + " % ("
              + formatNumber((context.dataset.counts || [])[context.dataIndex] || 0) + ")"
          }
        } : {})
      },
      datalabels: (isLine || isGauge) ? false : {
        // Gestapelt, Kreis und Ring: auf hellen Segmenten dunkle Schrift
        color:     valueOutside ? c.black
          : (isBar && isStacked ? context => context.dataset ? contrastText(context.dataset.backgroundColor, c.white, c.black) : c.white
          : (isPie ? context => {
              if (!context.dataset) return c.white;
              const colors = [].concat(context.dataset.backgroundColor);
              return contrastText(colors[context.dataIndex % colors.length], c.white, c.black);
            } : c.white)),
        anchor:    valueOutside ? "end"   : (isPie ? "end"    : "center"),
        align:     valueOutside ? "start" : (isPie ? "end"    : "center"),
        offset:    valueOutside ? defaults.offsetBarValue : (isPie ? defaults.offsetDoughnutValue : 0),
        font:      f.dataLabel,
        // Leere Werte (API liefert 0 als "") ohne Beschriftung statt nur mit Suffix
        formatter: isPercent ? formatPercent : v => (v === "" || v == null) ? null : formatNumber(v) + config.valueSuffix,
        // Gestapelt, Kreis und Ring: Werte in zu kleinen Segmenten ausblenden
        ...(isBar && isStacked ? {
          display: context => labelFitsSegment(context, isHorizontal,
            isPercent ? v => formatPercent(v) || "" : v => formatNumber(v) + config.valueSuffix)
        } : {}),
        ...(isPie ? {
          display: context => labelFitsArc(context, defaults.offsetDoughnutValue, v => formatNumber(v) + config.valueSuffix)
        } : {})
      }
    },
    scales: !isPie ? {
      [valueAxis]: {
        beginAtZero: true,
        stacked:     isStacked,
        grid:        { display: config.showGrid },
        // 100 %: Achse fest 0–100 %
        ...(isPercent ? { max: 100 } : {}),
        ticks: {
          color:    c.black,
          font:     f.axisTicks,
          stepSize: isPercent ? PERCENT_STEP : getStepSize(chartData, config),
          callback: isPercent ? v => v + " %" : v => formatNumber(v),
          // Horizontal: Zahlen unten nicht schräg stellen
          ...(isHorizontal ? { maxRotation: 0 } : {})
        }
      },
      [categoryAxis]: {
        stacked: isStacked,
        grid:    { display: false },
        ticks: showCategoryTicks ? {
          display:      true,
          padding:      10,
          color:        c.black,
          font:         f.axisTicks,
          ...(rotateCategory ? { maxRotation: calculatedRotation, minRotation: minRotation } : {}),
          ...(isHorizontal ? {
            callback: function (value) {
              // Mehrzeilige Labels (z. B. 100 % mit Gesamtzahl) unverändert übernehmen
              const raw = this.getLabelForValue(value);
              if (Array.isArray(raw)) return raw;

              const tickCtx = this.chart.ctx;
              tickCtx.save();
              tickCtx.font = (f.axisTicks.size || 12) + "px " + (f.axisTicks.family || "sans-serif");
              const wrapped = wrapLabel(
                raw,
                this.chart.width * LABEL_MAX_SHARE,
                text => tickCtx.measureText(text).width
              );
              tickCtx.restore();
              return wrapped;
            }
          } : {})
        } : { display: false }
      }
    } : undefined,
    animation: {
      duration: defaults.animationDuration,
      easing:   "easeOutQuart"
    }
  };

  if (config.type === "doughnut" || isGauge) options.cutout = config.doughnutCutout;
  if (isGauge) {
    options.circumference = 180;
    options.rotation      = -90;
  }

  // Legende mit Werten: Hover auf dem Chart hebt den Legenden-Eintrag hervor
  if (isDetailedLegend) {
    options.onHover = (event, elements) => highlightLegend(getCachedElement(legendId), elements.length ? elements[0].index : null);
    canvas.addEventListener("mouseleave", () => highlightLegend(getCachedElement(legendId), null));

    // Platz, damit das herausgerückte Segment nicht abgeschnitten wird
    if (isPie) {
      const pad = options.layout.padding;
      pad.top    = Math.max(pad.top, DETAILED_HOVER_OFFSET);
      pad.bottom = Math.max(pad.bottom, DETAILED_HOVER_OFFSET);
      pad.left   = Math.max(pad.left, DETAILED_HOVER_OFFSET);
      pad.right  = Math.max(pad.right, DETAILED_HOVER_OFFSET);
    }
  }

  const chart = sfs.myCharts[config.canvasId] = new Chart(ctx, {
    type:    isGauge ? "doughnut" : config.type,
    data:    chartData,
    options: options,
    plugins: isGauge ? [legendSpacingPlugin, gaugeTextPlugin] : [legendSpacingPlugin]
  });

  if (isGauge) {
    chart.$sfsGauge = {
      suffix: config.valueSuffix,
      label:  config.goalLabel.replace("{goal}", formatNumber(config.goal))
    };
    chart.draw();
  }

  if (useOwnLegend) renderLegend(chart);
  setAriaLabel(canvas, chartData, config, ariaKind);
};

// ─── Chart neu laden ─────────────────────────────────────────────────────────

sfs.reloadChart = async config => {
  config.lastLoad = Date.now();

  // Jede Anfrage bekommt eine Nummer; nur die Antwort der neuesten wird verwendet
  const requestId = config.requestId = (config.requestId || 0) + 1;
  config.loading = true;

  let data;
  try {
    data = await requestData(
      config.apiProxyUrl,
      config.apiEndpoint,
      config.apiEndpointFilter,
      config.useDatasets,
      config.localDatasets,
      config.stacked,
      config.chartLang
    );
  } finally {
    if (requestId === config.requestId) config.loading = false;
  }

  // Inzwischen wurde neuer geladen (z. B. Wechsel mobil/desktop) → veraltete Antwort verwerfen
  if (requestId !== config.requestId) return;

  // API-Fehler: bestehender Chart behält die letzten Daten, neuer Chart startet leer
  if (data === null) {
    if (sfs.myCharts[config.canvasId]) return;
    sfs.createChart({ labels: [], datasets: [] }, config);
    return;
  }

  sfs.createChart(data, config);
};

// ─── Chart zerstören (Timer bereinigen) ──────────────────────────────────────
// FIX 3 (Timer): Öffentliche Funktion zum sauberen Entfernen eines Charts,
//                z.B. bei SPA-Navigation oder dynamisch ausgeblendetem Content.

sfs.destroyChart = canvasId => {
  if (sfs.refreshTimers[canvasId]) {
    clearInterval(sfs.refreshTimers[canvasId]);
    delete sfs.refreshTimers[canvasId];
  }
  if (sfs.myCharts[canvasId]) {
    sfs.myCharts[canvasId].destroy();
    delete sfs.myCharts[canvasId];
  }
  delete sfs.chartConfigs[canvasId];
  sfs.elementCache.delete(canvasId);
};

// ─── IntersectionObserver + Initialisierung ──────────────────────────────────

const observeAndAnimateChart = (canvas, config) => {
  sfs.chartConfigs[config.canvasId] = config;

  const load = async () => await sfs.reloadChart(config);
  const shouldRefresh = !config.useDatasets && config.apiEndpoint && config.apiRefresh > 0;

  const startRefreshTimer = () => {
    if (!shouldRefresh) return;
    if (sfs.refreshTimers[config.canvasId]) clearInterval(sfs.refreshTimers[config.canvasId]);
    // Nicht nachladen im versteckten Tab (siehe visibilitychange unten) und
    // solange die vorherige Anfrage noch läuft (langsame API → kein Stau)
    sfs.refreshTimers[config.canvasId] = setInterval(() => {
      if (!document.hidden && !config.loading) load();
    }, config.apiRefresh);
  };

  if (config.optionAnimation) {
    canvas.style.opacity   = 0;
    canvas.style.transition = "opacity 0.5s ease-out";

    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= sfs.chartDefaults.observerThreshold) {
          obs.unobserve(entry.target);
          setTimeout(async () => {
            await load();
            canvas.style.opacity = 1;
            startRefreshTimer();
          }, 500);
        }
      });
    }, { threshold: sfs.chartDefaults.observerThreshold });

    obs.observe(canvas);
  } else {
    (async () => {
      await load();
      startRefreshTimer();
    })();
  }
};

// ─── Initialisierung ─────────────────────────────────────────────────────────
// Startet bei DOMContentLoaded bzw. sofort, wenn das Skript später eingebunden
// wird (async, nachgeladen) und das DOM bereits fertig ist.

const initCharts = () => {
  // FIX 1: Theme erst hier initialisieren, wenn alle Stylesheets geladen sind
  initChartTheme();

  document.querySelectorAll("canvas[id^='chart-']").forEach(canvas => {
    const d = canvas.dataset;
    const parsedColors       = (d.colors || sfs.chartColorsConfig.red).split(",").map(c => c.trim());
    const parsedLocalDatasets = d.localDatasets ? parseFlexibleLocalData(decodeBase64Utf8(d.localDatasets)) : "";
    const parsedApiProxyUrl   = d.apiProxyUrl   ? decodeBase64Utf8(d.apiProxyUrl) : "";

    observeAndAnimateChart(canvas, {
      canvasId:               canvas.id,
      chartLang:              d.chartLang || "DE",
      type:                   d.type,
      stacked:                d.stacked === "true",
      horizontal:             d.indexAxis === "y",
      grouped:                d.grouped === "true",
      percent:                d.percent === "true",
      percentTotalLabel:      d.percentTotalLabel || "",
      legendStyle:            d.legendStyle === "detailed" ? "detailed" : "simple",
      goal:                   parseFloat(d.goal) || 0,
      goalLabel:              d.goalLabel || "",
      valueSuffix:            d.valueSuffix || "",
      datasetsTitle:          d.datasetsTitle,
      datasetsTitleBold:      d.datasetsTitleBold,
      chartColors:            parsedColors,
      pluginTooltip:          d.pluginTooltip !== "false",
      layoutPaddingTop:       parseInt(d.layoutPaddingTop)  || 0,
      layoutPaddingBottom:    parseInt(d.layoutPaddingBottom) || 0,
      optionAnimation:        d.optionAnimation && d.optionAnimation.toLowerCase() === "true",
      showGrid:               d.showGrid === "true",
      stepSize:               parseInt(d.stepSize)    || 5,
      barThickness:           parseInt(d.barThickness) || 40,
      barThresholdMobile:     parseInt(d.barThresholdMobile)      || 3,
      barXAxisRotationMobile: parseInt(d.barXAxisRotationMobile)  || 90,
      barXAxisRotationDesktop:parseInt(d.barXAxisRotationDesktop) || 45,
      useDatasets:            d.useDatasets && d.useDatasets.toLowerCase() === "true",
      localDatasets:          parsedLocalDatasets,
      doughnutCutout:         d.doughnutCutout || (d.type === "gauge" ? "75%" : "60%"),
      apiEndpoint:            d.apiEndpoint,
      apiEndpointFilter:      d.apiEndpointFilter,
      apiRefresh:             parseInt(d.apiRefresh) || 60000,
      apiProxyUrl:            parsedApiProxyUrl,
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCharts);
} else {
  initCharts();
}

// ─── Tab wieder sichtbar ─────────────────────────────────────────────────────
// Überfällige Charts sofort nachladen (Polling pausiert in versteckten Tabs)

document.addEventListener("visibilitychange", () => {
  if (document.hidden) return;

  Object.values(sfs.chartConfigs).forEach(config => {
    if (sfs.refreshTimers[config.canvasId] && !config.loading && Date.now() - (config.lastLoad || 0) >= config.apiRefresh) {
      sfs.reloadChart(config);
    }
  });
});

// ─── Resize-Handler ──────────────────────────────────────────────────────────
// Die Grösse passt Chart.js selbst an (responsive). Neu geladen wird nur beim
// Wechsel mobil/desktop: API-Parameter "mobile" und Label-Drehung ändern sich.
// Höhenänderungen (z. B. Adressleiste auf dem Handy) lösen nichts aus.

let resizeTimeout;
let lastIsMobile = isMobileView();
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const isMobile = isMobileView();
    if (isMobile === lastIsMobile) return;
    lastIsMobile = isMobile;

    // Noch nicht sichtbare Charts (Lazy Load) werden beim Einblenden passend erstellt
    Object.values(sfs.chartConfigs).forEach(config => {
      if (sfs.myCharts[config.canvasId]) sfs.reloadChart(config);
    });
  }, 300);
});

window.decodeBase64Utf8 = decodeBase64Utf8;

})();